import { render, staticRenderFns } from "./H5Layout.vue?vue&type=template&id=79388fa6"
import script from "./H5Layout.vue?vue&type=script&lang=js"
export * from "./H5Layout.vue?vue&type=script&lang=js"
import style0 from "./H5Layout.vue?vue&type=style&index=0&id=79388fa6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports